// Image paths - using CDN URLs for reliability
export const IMAGES = {
  // Logo
  logo: 'https://customer-assets.emergentagent.com/job_8145a066-fedb-486e-a4a3-dc3591b8114e/artifacts/rcv1mw2l_TOF.png',
  
  // Founders
  foundersCover: 'https://customer-assets.emergentagent.com/job_tofin-redesign/artifacts/ckva3ztb_FBCover.png',
  abhinav: 'https://customer-assets.emergentagent.com/job_tofin-redesign/artifacts/igsdv64p_CAAbhinavPlain.png',
  aneesh: 'https://customer-assets.emergentagent.com/job_tofin-redesign/artifacts/7c02s09x_CAAneeshPlain.png',
  jeetesh: 'https://customer-assets.emergentagent.com/job_tofin-redesign/artifacts/hm8pqv6e_JeeteshMathur.png',
  
  // Testimonials
  vivek: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/l0d9hhpn_Vivek.png',
  uday: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/z17wmqm6_Uday.png',
  ved: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/cmiwxnvj_Ved.png',
  sukhet: 'https://customer-assets.emergentagent.com/job_tofin-redesign/artifacts/dcctakwk_Sukhet.png',
  mohit: 'https://customer-assets.emergentagent.com/job_tofin-redesign/artifacts/3tm7t19z_Mohit.png',
  chetan: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/6xjcpwen_Chetan.png',
  basant: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/bj554f2m_Basant.png',
  aayush: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/beasbglf_Aayush.png',
  
  // Events
  event1: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/ueudi4lq_1.png',
  event2: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/9w55rau2_2.png',
  event3: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/ii02h2mf_3.png',
  event4: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/20wwsggx_4.png',
  event5: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/kc7y39lo_5.png',
  
  // Press
  press1: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/gh9qdda3_PHOTO-2025-06-29-10-03-11.jpg',
  press2: 'https://customer-assets.emergentagent.com/job_d818e732-c38d-468c-8f77-a2042c825f5a/artifacts/ndcgw4pw_PHOTO-2025-06-29-10-03-10.jpg',
};
